import images from "../../assets";

export default function StartChattingProfile(props) {
  return (
    <div className="chatting-profile-img">
      <img className="start-chatting-profile" src={props.image} alt="" />
      <img
        className="start-chatting-profile-active"
        src={images.cardActive}
        alt=""
      />
    </div>
  );
}
